export default __webpack_public_path__ + "static/img_case_01-90398357558e202d2dc69ebe147e4309.webp";